import TopSites from './top_sites';

export default TopSites;
